/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SafeResourceUrl } from '@angular/platform-browser';
import { UtilsService } from '../../../../../core/services';
import { environment } from '../../../../../../environments/environment';

@Component({
    selector: 'app-adcs-overview',
    templateUrl: './adcs.overview.component.html',
    styleUrls: ['../../../../../../assets/shared/scss/inputs.scss']
})

export class AdcsOverviewComponent {
    /**
     * iframe url.
     */
    public contentUrl: SafeResourceUrl;

    constructor(
        private router: Router,
        private utilsService: UtilsService
    ) {
        this.contentUrl = this.utilsService.sanitiseExternalUrl(environment.externalResourceUrl + 'adc');
    }

    /**
     * Navigate to new route.
     * @param url
     */
    public navigate(url): void {
        this.router.navigate([url]).then(() => {
        });
    }
}
